function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import get from 'lodash/get';
import map from 'lodash/map';
import { useAction } from 'hooks';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import Account from 'modules/Account';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import OrganizationMemberships from './OrganizationMemberships';
import styles from './ClinicMemberships.pcss';
const ClinicMemberships = ()=>{
    useStyles(styles);
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const clinicMemberships = useSelector(selectors.clinicMemberships);
    const organizationUID = get(activeClinicMembership, 'clinic.organizationUID');
    const clinicId = get(activeClinicMembership, 'clinicId');
    const isClinicAdmin = get(activeClinicMembership, 'isAdmin');
    const fetchOrganizationMemberships = useAction(actions.fetchOrganizationMemberships, organizationUID, [
        'Invitation',
        'Pending'
    ]);
    const fetchClinicMemberships = useAction(actions.fetchClinicMemberships, clinicId);
    const manageOrganization = useAction(actions.manageOrganization, organizationUID);
    useEffect(()=>{
        fetchOrganizationMemberships();
        fetchClinicMemberships();
    }, []);
    const renderManageOrganizationBtn = ()=>/*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: messages.buttons.manageOrganization,
            className: "btn--filled",
            onClick: manageOrganization
        });
    const renderHcpAvatar = (profile)=>{
        if (!profile) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: profile.avatar,
            name: [
                profile.firstName,
                profile.lastName
            ],
            className: styles.avatar,
            imgClassName: styles.avatar__img,
            initialsClassName: styles.avatar__initials
        });
    };
    const renderLastSuccessfulLogin = (clinicMembership)=>{
        if (!isClinicAdmin) {
            return null;
        }
        const lastSuccessfulLoginTimestamp = get(clinicMembership, 'profile.lastSuccessfulLoginTimestamp');
        return /*#__PURE__*/ _jsx("td", {
            children: moment.unix(lastSuccessfulLoginTimestamp).local().format('L LT')
        });
    };
    const renderLastFailedLogin = (clinicMembership)=>{
        if (!isClinicAdmin) {
            return null;
        }
        const lastFailedLoginAttemptTimestamp = get(clinicMembership, 'profile.lastFailedLoginAttemptTimestamp');
        return /*#__PURE__*/ _jsx("td", {
            children: lastFailedLoginAttemptTimestamp ? moment.unix(lastFailedLoginAttemptTimestamp).local().format('L LT') : null
        });
    };
    const renderMembership = (clinicMembership)=>{
        const { clinicHcpMembershipId, profile, hcpBusinessEmail, isAdmin } = clinicMembership;
        return /*#__PURE__*/ _jsxs("tr", {
            className: "section__table__row",
            children: [
                /*#__PURE__*/ _jsx("td", {
                    className: "cell--avatar",
                    children: renderHcpAvatar(profile)
                }),
                /*#__PURE__*/ _jsxs("td", {
                    className: "w-25",
                    "data-hj-suppress": true,
                    children: [
                        profile === null || profile === void 0 ? void 0 : profile.firstName,
                        " ",
                        profile === null || profile === void 0 ? void 0 : profile.lastName
                    ]
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: hcpBusinessEmail
                }),
                renderLastSuccessfulLogin(clinicMembership),
                renderLastFailedLogin(clinicMembership),
                /*#__PURE__*/ _jsx("td", {
                    children: isAdmin && 'Admin'
                })
            ]
        }, clinicHcpMembershipId);
    };
    const renderTableBody = ()=>/*#__PURE__*/ _jsx("tbody", {
            className: "section__table__body",
            children: map(clinicMemberships, (clinicMembership)=>renderMembership(clinicMembership))
        });
    const renderLastSuccessfulLoginHead = ()=>{
        if (!isClinicAdmin) {
            return null;
        }
        return /*#__PURE__*/ _jsx("th", {
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.lastLogin))
        });
    };
    const renderLastFailedLoginHead = ()=>{
        if (!isClinicAdmin) {
            return null;
        }
        return /*#__PURE__*/ _jsx("th", {
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.lastLoginFailed))
        });
    };
    const renderTableHead = ()=>/*#__PURE__*/ _jsx("thead", {
            className: "section__table__head",
            children: /*#__PURE__*/ _jsxs("tr", {
                children: [
                    /*#__PURE__*/ _jsx("th", {
                        colSpan: 2,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.hcp))
                    }),
                    /*#__PURE__*/ _jsx("th", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.email))
                    }),
                    renderLastSuccessfulLoginHead(),
                    renderLastFailedLoginHead(),
                    /*#__PURE__*/ _jsx("th", {
                        "aria-label": "Admin"
                    })
                ]
            })
        });
    const renderMemberships = ()=>/*#__PURE__*/ _jsx("div", {
            className: "section__table-container",
            children: /*#__PURE__*/ _jsxs("table", {
                className: "section__table",
                children: [
                    renderTableHead(),
                    renderTableBody()
                ]
            })
        });
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("h2", {
                className: "section__header d-flex align-items-end justify-content-between",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "d-block",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.clinicHcps))
                    }),
                    renderManageOrganizationBtn()
                ]
            }),
            renderMemberships(),
            /*#__PURE__*/ _jsx(OrganizationMemberships, {
                status: "Pending",
                headerMessage: messages.headers.clinicHcpPending
            }),
            /*#__PURE__*/ _jsx(OrganizationMemberships, {
                status: "Invitation",
                headerMessage: messages.headers.clinicHcpInvitations
            })
        ]
    });
};
export default ClinicMemberships;
